module.exports = __webpack_public_path__ + "img/img23.029a6a2f.jpg";